import dayjs from 'dayjs';
export default {
  name: 'groupbuy_company_sel',
  data: function data() {
    return {
      dayjs: dayjs,
      searchForm: {
        page: 1,
        limit: 5,
        searchKey: null,
        sortField: 'create_time'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0
    };
  },
  mounted: function mounted() {
    this.query();
  },
  methods: {
    sel: function sel(rowData) {
      this.$emit('child-company-sel', rowData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    },
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.$api.groupBuyCompanyQueryJoinUser(this.searchForm).then(function (res) {
        _this.tableData = res.data || [];
        _this.totalCount = res.count;
        _this.queryLoading = false;
      });
    }
  }
};